module.exports = __webpack_public_path__ + "static/media/kde_neon_bg.37be6b29.png";